<template>
  <div class="LoginLayout">
    <div class="row w-100 h-100 gx-0">
      <!-- banner -->
      <div class="col-lg-7 col-12 d-lg-block p-0">
        <Banner />
      </div>
      <!-- login form -->
      <div class="col-lg-5 col-12 p-4 login-form d-flex flex-column align-items-center justify-content-lg-center">
        <div class="h-auto form-wrapper">
          <LoginHeader/>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/UI/Banner";
// import Footer from "../components/UI/Footer";
import LoginHeader from "./LoginHeader";

export default {
  name: "LoginLayout",
  components: {
    LoginHeader,
    // Footer,
    Banner
  },
  props: ['withRightImg']
}
</script>

<style lang="scss">
@import "src/styles/modules/Layout/LoginLayout";
</style>